import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-down-circle_5b4c6",
  "use": "arrow-down-circle_5b4c6-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"arrow-down-circle_5b4c6\">\n    <path fill-rule=\"evenodd\" d=\"M2.929 2.929c3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142zM5 9l5 5 5-5-2-2-3 3-3-3-2 2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol